type Item = {
  label: string;
  value: string;
};

const ITEMS: readonly Item[] = [
  { label: "Typical team size", value: "15 to 200+ people" },
  { label: "Delivery", value: "Hybrid - in-person and async" },
  { label: "Geography", value: "Worldwide" },
];

export default function BusinessEngagements() {
  return (
    <section
      id="business-engagements"
      className="w-full bg-black font-fira text-white py-6 md:py-20"
    >
      <div className="mx-auto w-[90%] md:w-[80%]">
        <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF]">
          How engagements work
        </p>
        <h2 className="mt-3 font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:mt-4 md:text-[42px] md:font-semibold">
          Scoped to team size and goals
        </h2>
        <p className="mt-3 font-fira text-sm font-normal leading-relaxed text-[#FFFFFF85] md:mt-4 md:text-base">
          Most engagements run across 8 to 12 weeks with ongoing support built
          in.
        </p>

        <div className="mt-8 flex flex-col rounded-2xl border border-[#FFFFFF33] md:mt-10 md:flex-row md:rounded-[20px]">
          {ITEMS.map((item, i) => {
            const isLast = i === ITEMS.length - 1;
            return (
              <div
                key={item.label}
                className={`flex-1 px-5 py-6 md:px-8 md:py-7 ${
                  !isLast
                    ? "border-b border-[#FFFFFF33] md:border-b-0 md:border-r"
                    : ""
                }`}
              >
                <p className="font-fira text-xs font-normal uppercase tracking-[0.18em] text-[#FFFFFF85] md:text-sm">
                  {item.label}
                </p>
                <p className="mt-2 font-fira-condensed text-[18px] font-medium leading-snug text-white md:mt-3 md:text-[22px]">
                  {item.value}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
